var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C7 3 3 7 3 12C3 13.8 3.6 15.6 4.6 17.1L3.2 19.5C3 19.8 3 20.2 3.2 20.5C3.4 20.8 3.6 21 4 21H12C17 21 21 17 21 12C21 7 17 3 12 3ZM12 19H5.8L6.7 17.5C6.9 17.1 6.9 16.7 6.6 16.4C5.6 15.2 5 13.6 5 12C5 8.1 8.1 5 12 5C15.9 5 19 8.1 19 12C19 15.9 15.9 19 12 19Z",
    fill: "#505780"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1001 7.30005H12.0001C11.0001 7.30005 10.1001 7.80005 9.60009 8.60005C9.20009 9.10005 9.30009 9.70005 9.80009 10C10.3001 10.3 10.9001 10.2 11.2001 9.70005C11.4001 9.40005 11.7001 9.30005 12.0001 9.30005H12.1001C12.6001 9.30005 13.0001 9.70005 13.0001 10.2C13.0001 10.6 12.7001 11 12.4001 11.1L11.7001 11.3C11.3001 11.4 11.0001 11.8 11.0001 12.2V13C11.0001 13.6 11.4001 14 12.0001 14C12.5001 14 13.0001 13.6 13.0001 13.1C14.2001 12.7 15.0001 11.6 15.0001 10.3C15.0001 8.70005 13.7001 7.30005 12.1001 7.30005Z",
    fill: "#505780"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
    fill: "#505780"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/Faq.de802cde0760f22c192a759bebc2809b.svg";
export { ForwardRef as ReactComponent };